import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface Occupant {
  uuid: string;
  name: string;
  avatar_url: string;
  avatar_thumbnail_url?: string | null;
}

interface Room {
  uuid: string;
  name: string;
  background_url: string;
  occupants: Occupant[];
}

interface PresenceState {
  currentRoom: Room;

  // Actions
  setCurrentRoom: (room: Room) => void;
  updateOccupants: (occupants: Occupant[]) => void;
  reset: () => void;
}

// Default room data
const defaultRoom: Room = {
  uuid: '106d4c07-dff6-4c14-8ed5-4acb898bb386',
  name: "Tony Stark's Office",
  background_url:
    'https://nexgen-dev-org-files-public.s3.us-east-1.amazonaws.com/app/defaults/office-bg.jpg',
  occupants: [],
};

export const usePresenceStore = create<PresenceState>()(
  persist(
    (set) => ({
      currentRoom: defaultRoom,

      setCurrentRoom: (room) =>
        set(() => ({
          currentRoom: room,
        })),

      updateOccupants: (occupants) =>
        set((state) => ({
          currentRoom: { ...state.currentRoom, occupants },
        })),

      reset: () =>
        set(() => ({
          currentRoom: defaultRoom,
        })),
    }),
    {
      name: 'presence-storage',
      partialize: (state) => ({
        // Only persist the room ID, not the occupants which are dynamic
        currentRoom: {
          pid: state.currentRoom.pid,
          name: state.currentRoom.displayName,
          background_url: state.currentRoom.background_url,
        },
      }),
    }
  )
);
